module.exports = __webpack_public_path__ + "img/xiangjin2.ba042551.png";